<template>

  <section
    v-if="banner"
    class="bulk-issue-banner"
    :class="`bulk-issue-banner--${banner.tone}`"
  >

    <div class="bulk-issue-banner__icon">
       <i
        :class="banner.icon"
        aria-hidden="true"
      ></i
      >
    </div>

    <div class="bulk-issue-banner__body">
       <strong class="bulk-issue-banner__title">{{ banner.title }}</strong
      >
      <p class="bulk-issue-banner__text">{{ banner.text }}</p>

    </div>

  </section>

</template>

<script>
  export default {
    name: 'BulkIssueStateBanner',
    props: {
      phase: {
        type: String,
        default: 'idle',
      },
      errorMessage: {
        type: String,
        default: '',
      },
      blockedCount: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      banner() {
        if (this.phase === 'preChecking') {
          return {
            tone: 'info',
            icon: 'fas fa-sync-alt',
            title: 'Đang kiểm tra trước phát hành',
            text: 'Đối chiếu điều kiện phát hành, trạng thái hiện tại và tổng giá trị đủ điều kiện.',
          }
        }

        if (this.phase === 'error') {
          return {
            tone: 'danger',
            icon: 'fas fa-exclamation-circle',
            title: 'Không thể hoàn tất bước kiểm tra',
            text: this.errorMessage || 'Kiểm tra trước phát hành thất bại. Vui lòng thử lại.',
          }
        }

        if (this.phase === 'zeroEligible') {
          return {
            tone: 'warning',
            icon: 'fas fa-shield-alt',
            title: 'Không có hóa đơn nào vượt qua pre-check',
            text: `${this.blockedCount} hóa đơn đang bị chặn và cần được rà soát trước khi quay lại danh sách.`,
          }
        }

        return null
      },
    },
  }
</script>

<style scoped>
  .bulk-issue-banner {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    padding: 0.85rem 1rem;
    border: 1px solid #dce5f0;
    border-radius: 12px;
    background: #fff;
  }

  .bulk-issue-banner--info {
    border-color: #d5e6ff;
    background: #f5f9ff;
  }

  .bulk-issue-banner--warning {
    border-color: #f0ddae;
    background: #fffaf0;
  }

  .bulk-issue-banner--danger {
    border-color: #efc7cd;
    background: #fff7f8;
  }

  .bulk-issue-banner__icon {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: rgba(24, 125, 228, 0.08);
    color: #187de4;
    flex: 0 0 auto;
  }

  .bulk-issue-banner--warning .bulk-issue-banner__icon {
    background: rgba(201, 138, 21, 0.12);
    color: #c98a15;
  }

  .bulk-issue-banner--danger .bulk-issue-banner__icon {
    background: rgba(201, 76, 95, 0.12);
    color: #c94c5f;
  }

  .bulk-issue-banner__title {
    display: block;
    color: #1f2a3d;
    font-size: 0.92rem;
    font-weight: 700;
  }

  .bulk-issue-banner__text {
    margin: 0.2rem 0 0;
    color: #556274;
    font-size: 0.82rem;
    line-height: 1.45;
  }
</style>

